import dayjs from 'dayjs';

export function dateFormat(
  dateString: string | Date | number | dayjs.Dayjs,
  foramt: string = 'YYYY.MM.DD'
) {
  return dayjs(dateString).format(foramt);
}
